import React, { Component } from "react";
import Button from "../shared/buttons/Button";
import { withRouter } from "react-router";
import { ButtonConfig } from "../../constants/Constants";

export class HomeHeadingActionButton extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.history.push(this.props.LinkTo);
  }

  render() {
    return (
      <div className="home-heading-action-button">
        <div className="home-hero-heading">{this.props.Heading}</div>
        <Button
        id={ButtonConfig.contactUs}
          buttonType={this.props.buttonType}
          label={this.props.LinkText}
          onClick={this.onClick}
        />
      </div>
    );
  }
}

export default withRouter(HomeHeadingActionButton);
